import { CurrencyPipe, NgFor, NgIf, NgOptimizedImage } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { QtyComponent } from 'src/app/atoms/qty/qty.component';
import { CartLine } from 'src/app/classes/utility';
import { TitleExtractorPipe } from 'src/app/pipe/product-title.pipe';
import { ShopifyService } from 'src/app/service/shopify.service';

@Component({
  selector: 'app-lineitem',
  imports: [
    CurrencyPipe,
    NgIf,
    NgFor,
    QtyComponent,
    TitleExtractorPipe,
    NgOptimizedImage,
  ],
  templateUrl: './lineitem.component.html',
  styleUrl: './lineitem.component.scss',
})
export class LineitemComponent implements OnChanges {
  _bundle: any;
  @Input() lineItem!: CartLine;
  _gwpMode: boolean = false;
  constructor(private shopifyService: ShopifyService) {}

  async remove() {
    await lastValueFrom(this.shopifyService.removeFromCart([this.lineItem.id]));
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.lineItem.merchandise.selectedOptions =
      this.lineItem.merchandise.selectedOptions.filter(
        (x) => x.value != 'Default Title'
      );
    if (this.lineItem.attributes.length > 0) {
      this._gwpMode = this.lineItem.attributes.find(
        (x) => x.key == '_gwp' || x.key == '_bxgy'
      )
        ? true
        : false;
      this.lineItem.attributes = this.lineItem.attributes.filter(
        (x: any) => !x.key.startsWith('_')
      );
    }
  }
}
